import QRCode from 'qrcode';

export async function initQRCodeFromImg( img: HTMLImageElement ): Promise<void> {
    const dataURL = await QRCode.toDataURL( img.dataset.codeContent, {
        errorCorrectionLevel: window.qrErrLvl || 'L',
        margin: window.qrMargin || 0,
        width: img.getAttribute( 'width' ) || 100,
    } );

    img.src = dataURL;
}
